
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import conf from "./../../config/base.js";
import {
invoiceTypeArray,
sellerInvoiceStatusArray
} from "@/common/js/const";
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Search from 'vux/src/components/search/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


import scrollerEdit from '../invoice/scroller-edit'

export default {
directives: {
TransferDom
},
components: {
Box,
Group,
PopupPicker,
Datetime,
Scroller,
scrollerEdit,
Spinner,
Cell,
CellBox,
XHeader,
Flexbox,
FlexboxItem,
Search,
XInput
},
data() {
return {
groupNameOrUnicode:'',
isWechat: ____isWechatBrowser(),
showInvoiceTypePicker: false,
invoiceTypePickerValue: [],
invoiceTypeList: [],
showDocumentStatusPicker: false,
documentStatusPickerValue: [],
documentStatusList: [],

invoices: [],
latestInvoiceViewId: "", //每次点击进入详情，都要给此值赋值

scrollerHeight:
____invoiceScrollerHeight -
(this.$route.meta.showTabbar ? 55 : 0) +
"px",
scrollerStatus: {
pullupStatus: "default",
pulldownStatus: "default"
},
pullupEnabled: true,
scrollerPullupConfig: {
content: this.$t("上拉加载更多"),
downContent: this.$t("松开加载"),
upContent: this.$t("上拉加载更多"),
loadingContent: this.$t("加载中"),
height: 50,
autoRefresh: false
},
scrollerPulldownConfig: {
content: this.$t("下拉刷新"),
downContent: this.$t("松开刷新"),
upContent: this.$t("松开刷新"),
loadingContent: this.$t("加载中"),
height: 50,
autoRefresh: false
},
search: {
type: this.$t("分类"),
typeId: "",
status: this.$t("状态"),
statusId: "",
date: this.$dateFormat(new Date(), "YYYYMMDD"),
dateDisplayName: this.$dateFormat(new Date(), "YYYY-MM"), //this.$t("日期"),
pageIndex: 1,
pageSize: 10
}
};
},
created() {},
activated() {
var $self = this;

$self.ACTION_setInvoiceIndexReload({
type: null,
reserve: ""
});
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {
...mapState({
STATE_InvoiceIndexReload: state => state.invoice.invoiceIndexReload
})
},
filters: {},
/**初始化的时候调用  类似于 ready */
mounted() {
var $self = this;

$self.invoiceTypeList = [invoiceTypeArray];

$self.documentStatusList = [sellerInvoiceStatusArray];
$self.$nextTick(() => {
$self.$refs.scroller1.reset({ top: 0 });
});
$self.loadData(true);
},
methods: {
...mapActions({
ACTION_setPageLoadingTrue: "common_ac_setPageLoadingTrue"
}),
...mapActions({
ACTION_setPageLoadingFalse: "common_ac_setPageLoadingFalse"
}),
...mapActions({
ACTION_setInvoiceIndexReload: "invoice_ac_setinvoiceIndexReload"
}),
searchGroupNameOrUnicode(){
this.loadData(true);
},

loadMore() {
var $self = this;
$self.loadData(false, function() {
setTimeout(() => {
$self.$refs.scroller1.donePullup();
}, 1200);
});
},

refresh() {
var $self = this;
$self.loadData(true, function() {
setTimeout(function() {
$self.$nextTick(() => {
setTimeout(() => {
$self.$refs.scroller1.donePulldown();
$self.pullupEnabled && $self.$refs.scroller1.enablePullup();
}, 10);
});
}, 1200);
});
},

loadData(firstLoad, callback) {
var $self = this;
if (firstLoad) {
$self.search.pageIndex = 1;
} else {
$self.search.pageIndex += 1;
}
var object = {
invoiceType: $self.search.typeId,
createTime: $self.search.date,
status: $self.search.statusId,
page: $self.search.pageIndex,
rows: $self.search.pageSize,
groupNameOrUnicode:this.groupNameOrUnicode
};
var params = {
dataMap: JSON.stringify(object)
};
$self.$webapi.sellerInvoiceList(params).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
if (res.data.result.list.length == 0) {


if (!firstLoad) {
$self.search.pageIndex--;
}
}
var tempInvoices = res.data.result.list.map(function(el) {
var seller = el.sellerName;
var iType = el.invoiceType;
if (!el.invoiceCode || !el.invoiceNo) {
seller = "发票开具中";
}

if(el.invoiceType=='c' && el.businessBillType == '6'){
iType = 'ce';
}
return {
__id: el.id,
topLeft: seller,
topRight: "￥" + $self.$thousandBitSeparator(el.price),
middleLeft:
el.purchaserName == "" ? "" : "购买方:" + el.buyerName,
middleLeft2:
el.handleTime == ""
? "发票日期:"
: "发票日期:" +
$self.$formatDateTime3(el.handleTime, "YYYY-MM-DD"), //上传日期:2018-02-12
middleRight: " ",
invoiceType: iType,
invoiceNo: el.invoiceNo,
invoiceCode: el.invoiceCode,
groupFlag: el.groupFlag,
};
});
if (firstLoad) {
$self.invoices = tempInvoices;
} else {
$self.invoices = $self.invoices.concat(tempInvoices);
}
} else {

if (!firstLoad) {
$self.search.pageIndex--;
}
if(firstLoad){
this.invoices = [];
this.$vux.toast.show({text: res.data.msg,type:'warn'});
}
}
$self.$nextTick(() => {
setTimeout(function() {
if (firstLoad) {
$self.$refs.scroller1.reset({ top: 0 });             } else {
$self.$refs.scroller1.reset(); 
}
}, 1000);
});

if (callback) {
callback();
}
});
},
changePullupStatus(enabled) {
var $self = this;
if (enabled) {
$self.$refs.scroller1.enablePullup();
$self.pullupEnabled = true;
} else {
$self.$refs.scroller1.disablePullup();
$self.pullupEnabled = false;
}
},

showDatePicker() {
var $self = this;
$self.$vux.datetime.show({
cancelText: this.$t("取消"),
confirmText: this.$t("确定"),
format: "YYYY-MM",
endDate: $self.$dateFormat(new Date(), "YYYY-MM-DD"),
value: $self.search.dateDisplayName,
onConfirm(val) {
$self.search.date = val.replace(/-/g, "") + "01";
$self.search.dateDisplayName = val;
$self.loadData(true);
}
});
},
linkToDetail(invoice) {
this.latestInvoiceViewId = invoice.__id;
this.$router.push("/orderinvoice/detail/" + invoice.invoiceNo + "/" + invoice.invoiceCode);
},

onInvoiceTypePickerChange(val) {
var $self = this;

$self.search.typeId = val[0];
$self.search.type = $self.invoiceTypeList[0].filter(function(el) {
return el.value == $self.search.typeId;
})[0].name;
$self.loadData(true);
},

onDocumentStatusPickerChange(val) {
var $self = this;
$self.search.statusId = val[0];
$self.search.status = $self.documentStatusList[0].filter(function(el) {
return el.value == $self.search.statusId;
})[0].name;

$self.loadData(true);
},

pageGoBack() {
var $self = this;
try {
if (____isAndroid) {
window.androidApi.backCalls();
} else {

window.iosApi.backCalls();
}
} catch (error) {

$self.$router.go(-1);
}
}
}
};
